import { useEffect, useState } from 'react';
export default (function () {
    var _a = useState({
        width: 0,
        height: 0,
        isMobile: false
    }), size = _a[0], setSize = _a[1];
    useEffect(function () {
        var updateSize = function () {
            var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
            setSize({
                width: innerWidth,
                height: innerHeight,
                isMobile: innerWidth < 768
            });
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return function () { return window.removeEventListener('resize', updateSize); };
    }, []);
    return size;
});
